import { mallApi, mallEntranceApi } from '../request'
import { apiPath } from '../api'

export const cms = {
  getById: data =>
    mallEntranceApi.post(
      apiPath.getById,
      Object.assign({}, data, {
        colorMode: 'origin'
      })
    ),
  getGoodsListByDataId: data =>
    mallApi.post(apiPath.getGoodsListByDataId, data),
  getSeckillInfo: data => mallApi.post(apiPath.getSeckillInfo, data),
  getSeckillSkuByTime: data => mallApi.post(apiPath.getSeckillSkuByTime, data),
  getSeckillInfoNew: data =>
    mallEntranceApi.post(apiPath.getSeckillInfoNew, data),
  getSecKillClass: data => mallEntranceApi.post(apiPath.getSecKillClass, data),
  getSecKillSkuByTimeRegion: data =>
    mallEntranceApi.post(apiPath.getSecKillSkuByTimeRegion, data),
  getPromotion: data => mallEntranceApi.post(apiPath.getPromotion, data),
  postSubscribe: data => mallApi.post(apiPath.subscribe, data),
  getMCPriceSsu: data => mallEntranceApi.post(apiPath.getMCPriceSsu, data),
  applyCreateActivity: data =>
    mallEntranceApi.post(apiPath.applyCreateActivity, data),
  getPlatformRulesCategory: data =>
    mallApi.post(apiPath.getPlatformRulesCategory, data),
  getPlatformRules: data => mallApi.post(apiPath.getPlatformRules, data)
}
